var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"fy_center_box"},[_c('img',{staticClass:"nofound_img",attrs:{"alt":"","src":require("@/static/image/common/404.png")}})])])
}]

export { render, staticRenderFns }